//Разметка страниц в рецептах

import React from 'react'; 
import './CounterPage.css';

export function CounterPage(props) {
  const { pages, currentPage, handleCounter } = props;
  const totalPages = pages.length;
  const step = 3; // Количество страниц, отображаемых одновременно
  const [start, setStart] = React.useState(0);
  const [end, setEnd] = React.useState(3);   
  
  React.useEffect(() => {
    if (currentPage > end) {
      setStart(currentPage - step);
      setEnd(currentPage); 
    } else if (currentPage < start) {
      setStart(currentPage - 1);
      setEnd(currentPage + step);
    } else if (currentPage === start) {
      setStart(currentPage - 1);
      setEnd(currentPage-1 + step);
    } 
  }, [currentPage]);
  
  let visiblePages = pages.slice(start, end); 
  
  function handleClickBack() {
    if (currentPage > 1) {
      handleCounter(currentPage - 1);
    }
  }
  
  function handleClickForward() {
    if (currentPage < totalPages) {
      handleCounter(currentPage + 1);
    }
  }
  
  return (
    <div className='pages-recipe'>
      {start > 0 && (
        <span className='page__number' onClick={() => handleCounter(1)}>1</span>
      )}
      <button type='button' 
        className={`${start === 0 ? 'gg-page-left-disabled' : 'gg-page-left'}`} 
        onClick={handleClickBack} 
        disabled={currentPage === 1} 
      />
      <div className='page-numbers'>
        {visiblePages.map(page => (
          <span key={page} className={page === currentPage ? 'page__active' : 'page__number'} onClick={() => handleCounter(page)}>
              {page}
          </span>
        ))}
      </div>
      <button type='button' 
        className={`${end === totalPages || totalPages < 3 ? 'gg-page-right-disabled' : 'gg-page-right'}`} 
        onClick={handleClickForward} 
        disabled={currentPage === totalPages} 
      />
      {end < totalPages && (
        <span className='page__number' onClick={() => handleCounter(totalPages)}>
          {totalPages}
        </span>
      )}
    </div>
    ); 
  }